import { Box } from '@mui/material';

import { SupplierInfo } from 'widgets/MiddleMan/lib';

import { SupplierCardHeader } from './SupplierCardHeader';
import { SupplierContactSection } from './SupplierContactSection';
import { SupplierShipmentSection } from './SupplierShipmentSection';

interface SupplierCardProps {
    supplierInfo: SupplierInfo;
}

export const SupplierCard = ({ supplierInfo }: SupplierCardProps) => {
    const isShipmentData = (supplierInfo.shipments?.length ?? 0) > 0;

    return (
        <Box
            sx={{
                borderRadius: '8px',
                p: '20px',
                mb: '20px',
                backgroundColor: 'grey.100',
                boxShadow: '0px 0px 4px 0px rgba(0, 0, 0, 0.13)',
            }}
        >
            <SupplierCardHeader
                name={supplierInfo.name}
                logo={supplierInfo.logo}
                accountNumber={supplierInfo.accountNumber}
            />

            <SupplierContactSection
                phone={supplierInfo.phone}
                email={supplierInfo.email}
                primaryContact={supplierInfo.primaryContact}
                primaryPhone={supplierInfo.primaryPhone}
                primaryEmail={supplierInfo.primaryEmail}
                hasBorderBottom={isShipmentData}
            />

            {isShipmentData && (
                <SupplierShipmentSection
                    shipments={supplierInfo.shipments ?? []}
                />
            )}
        </Box>
    );
};
